import config from '../Config';

export const today = +new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

export const parseDateDesktop = (input) => {
	if (config.date_today_tomorrow_label) {
		if (input === today) return customData.i18n.agenda_date_today;
		if (input === today + 86400000) return customData.i18n.agenda_date_tomorrow;
	}
  return new Date(input).toLocaleDateString(document.documentElement.lang, { weekday: 'long', month: 'long', day: 'numeric' });
};

export const parseDateDesktopShort = (input) => {
	if (config.date_today_tomorrow_label) {
		if (input === today) return customData.i18n.agenda_date_today.toLowerCase();
		if (input === today + 86400000) return customData.i18n.agenda_date_tomorrow.toLowerCase();
	}

  return new Date(input).toLocaleDateString(document.documentElement.lang, { weekday: 'long', month: 'short', day: 'numeric', year: "numeric" }); // slice to trim last "." after month name
};

export const parseDateDesktopMonth = (input) => {
  return new Date(input).toLocaleDateString(document.documentElement.lang, { month: 'long', year: "numeric" });
};

export const parseDateDay = (timestamp) => {
  return new Date(timestamp).toLocaleDateString(document.documentElement.lang, { weekday: 'long' }).substring(0, 2);
};

export const parseDateNumber = (timestamp) => {
  return new Date(timestamp).toLocaleDateString(document.documentElement.lang, { day: 'numeric' });
};

export const dbDateToTimestamp = (programstart) => {
  if (typeof programstart !== 'string') {
    programstart = programstart.toString();
  }
  return +new Date(`${programstart.substring(0, 4)}`, `${programstart.substring(4, 6) - 1}`, `${programstart.substring(6, 8)}`);
};

export const dbDateToExactTimestamp = (programstart) => {
  if (typeof programstart !== 'string') {
    programstart = programstart.toString();
  }
  return +new Date(
    `${programstart.substring(0, 4)}`,
    `${programstart.substring(4, 6) - 1}`,
    `${programstart.substring(6, 8)}`,
    `${programstart.substring(8, 10)}`,
    `${programstart.substring(10, 12)}`
  );
};

export const sortByPopularity = (input) => {
  const preSort = sortByRelease(input);
  return preSort.sort((a, b) => b.times.length - a.times.length);
};

export const sortByTime = (input) => {
  input.sort((a, b) => {
    return a.times[0].timestamp - b.times[0].timestamp;
  });
  return input;
};

export const sortByRelease = (input) => {
  let tempWithReleaseDate = input.filter((movie) => movie.dates.release);
  let tempWithoutReleaseDate = input.filter((movie) => !movie.dates.release);

  tempWithReleaseDate.sort((a, b) => {
    return dbDateToTimestamp(a.dates.release + '0000') - dbDateToTimestamp(b.dates.release + '0000');
  });

  if (tempWithoutReleaseDate.length > 0) {
    tempWithoutReleaseDate.sort((a, b) => a.title.localeCompare(b.title));
    return tempWithReleaseDate.concat(tempWithoutReleaseDate);
  } else {
    return tempWithReleaseDate;
  }
};

export const sortAlphabetically = (input) => {
  return input.sort((a, b) => a.title.localeCompare(b.title));
};

export const parseEntities = (txt) => {
  return new DOMParser().parseFromString(txt, 'text/html').body.innerText;
};

const bodyWidthEM = () => {
  console.log('window.intterwidth', window.innerWidth);
  console.log('computedStyle body', parseFloat(getComputedStyle(document.querySelector('body'))['font-size']));
  return window.innerWidth / parseFloat(getComputedStyle(document.querySelector('body'))['font-size']);
};

const checkForTouchScreen = () => {
  if ('ontouchstart' in document.documentElement) {
    return true;
  } else {
    return false;
  }
};

export const hideAgenda = (hideOnHomeDesktop) => {
  if (!document.querySelector('.js_react_filter').classList.contains('js_react_filter_home')) {
    return true;
  } else {
    if (!hideOnHomeDesktop) {
      return true;
      // } else if (bodyWidthEM() < 37.5) {
    } else if (checkForTouchScreen()) {
      return true;
    } else {
      return false;
    }
  }
};

export const vwSet = () => {
  document.documentElement.style.setProperty('--vw', `${document.documentElement.clientWidth / 100}px`);
};

export const scrollToBegin = (rootElement) => {
  const start = rootElement.querySelector('.tab-nav');
  if (start) {
    document.firstElementChild.style.scrollPaddingBlockStart = getComputedStyle(document.body).getPropertyValue('--header-height');
    start.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }
};

export const scrollToFromTime = (rootElement, filteredMovies) => {
  const nearestShow = filteredMovies.find((movie) => {
    return movie.times[0].timestamp > +new Date().getTime(); //future development: use fromTime here
  });
  const nearestShowElement = rootElement.querySelector(`#movie-${nearestShow.post_id}-${nearestShow.times[0].timestamp}`);
  document.firstElementChild.style.scrollPaddingBlockStart = getComputedStyle(document.body).getPropertyValue('--header-height');
  nearestShowElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
};
